import toast from 'react-hot-toast';
import {
  type LeavePlayRequestResponse,
  getPlayRequestLeaveApi,
} from 'constants/payloads/playRequests';
import { useApiGateway } from 'hooks/useApi';
import WarningConfirmModal from './WarningConfirmModal';

interface Props {
  /** The viewer's accepted request for the game. */
  requestId: string | null;
  isOpen: boolean;
  onClose: () => void;
  /** Runs after the viewer has left; the modal is already closed by then. */
  onLeft: () => void | Promise<unknown>;
}

/** "Leave game?" confirmation (Figma 2276-131660). Owns the leave call. */
export default function LeaveGameModal({ requestId, isOpen, onClose, onLeft }: Props) {
  const { post: leaveGame, isLoading: isLeaving } = useApiGateway<
    undefined,
    LeavePlayRequestResponse
  >();

  const handleConfirm = async () => {
    if (!requestId) return;
    const response = await leaveGame({ endpoint: getPlayRequestLeaveApi(requestId) });
    if (response.isError) {
      toast.error(response.error || 'Could not leave the game');
      return;
    }
    onClose();
    await onLeft();
  };

  return (
    <WarningConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      title="Leave game?"
      description="Once you leave, you will be removed from the group chat."
      confirmLabel="Leave game"
      onConfirm={handleConfirm}
      isConfirming={isLeaving}
    />
  );
}
